import { FormattedMessage } from "react-intl";
import Footer from "./Footer";

const MigrationInfo = () => {
    return (
        <div>
            <main className="mb-24">
                <div className='relative pt-24 sm:py-20 lg:pb-10'>
                    <div className='mx-auto max-w-6xl px-3 lg:px-8'>
                        <div className='mx-auto max-w-4xl text-center'>
                            <h1 className='text-4xl font-bold tracking-tight text-gray-900'>
                                <FormattedMessage id="migration.title" defaultMessage="MetEd has a new platform — here’s what you need to know" />
                            </h1>
                        </div>
                    </div>
                </div>

                <div className='mx-auto max-w-6xl divide-y divide-gray-900/10 px-4'>
                    <dl className='mt-10 space-y-6'>
                        
                        <dt className='text-lg font-semibold leading-7 text-gray-900 pt-6 border-t border-gray-900/10'>
                            <div className='flex w-full items-start justify-between text-left text-gray-900'>
                                <span className='text-lg font-semibold leading-7 text-gray-600'>
                                    <FormattedMessage id="migration.q1" defaultMessage="Why did you move MetEd to a new platform?" />
                                </span>
                            </div>
                        </dt>
                        <dd className="mt-2 pr-12">
                            <div className="text-lg leading-7 text-gray-600 preset-faq-answer">
                                <span className="mt-2 text-gray-600">
                                    <FormattedMessage id="migration.a1" defaultMessage="One word: Functionality. The new platform brings stronger tools to track learner progress, a personalized dashboard, and advanced AI to open new growth opportunities. It also features enhanced accessibility and superior functionality to deliver a more powerful, seamless learning experience to you." />
                                </span>
                            </div>
                        </dd>
                        
                        
                        <dt className="text-lg font-semibold leading-7 text-gray-900 pt-6 border-t border-gray-900/10">
                            <div className="flex w-full items-start justify-between text-left text-gray-900">
                                <span className="text-lg font-semibold leading-7 text-gray-600">
                                    <FormattedMessage id="migration.q2" defaultMessage="What do I need to know about this transition? " />
                                </span>
                                <span className="ml-6 flex h-7 items-center"></span>
                            </div>
                        </dt>
                        <dd className="mt-2 pr-12">
                            <div className="text-lg leading-7 text-gray-600 preset-faq-answer">
                                <ul className="list-disc pl-[40px] mt-2 text-gray-600 space-y-4">
                                    <li>
                                        <strong>
                                            <FormattedMessage id="migration.q2.1" defaultMessage="Do I need to create a new MetEd account?" />
                                        </strong>
                                        <br />
                                        <FormattedMessage id="migration.a2.1" defaultMessage="Yes. You'll need to create a new account. " />
                                        <br />
                                        <FormattedMessage id="migration.to_do_so" defaultMessage="To do so, please visit: " />
                                        <a href="https://learn.meted.ucar.edu/#/public-dashboard" className="text-blue-600 underline">learn.meted.ucar.edu/#/public-dashboard</a>.
                                    </li>
                                    <li>
                                        <strong>
                                            <FormattedMessage id="migration.q2.2" defaultMessage="Can I still access my records from the legacy MetEd platform?" />
                                        </strong>
                                        <br />
                                        <FormattedMessage id="migration.a2.2" defaultMessage="Yes. You can view and download your transcript, certificates, and course queue from the legacy system, until further notice." />
                                        <br />
                                        <FormattedMessage id="migration.to_do_so" defaultMessage="To do so, please visit: " />
                                        <a href="https://www.meted.ucar.edu/transcripts" className="text-blue-600 underline">www.meted.ucar.edu/transcripts</a>.
                                    </li>
                                    <li>
                                        <strong>
                                            <FormattedMessage id="migration.q2.3" defaultMessage="Will all MetEd content be available on the new platform?" />
                                        </strong>
                                        <br />
                                        <FormattedMessage id="migration.a2.3" defaultMessage="Yes. All MetEd content will be migrated in stages, starting with the most popular and recently published items. The remaining content will continue to be added until the full catalog is available." />
                                    </li>
                                </ul>
                            </div>
                        </dd>
                        
                    </dl>
                </div>
            </main>
            <Footer />
        </div>
    );
};

export default MigrationInfo;